import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './CancellableContinuationImpl.mjs';
import { get_DefaultDelay3q9fawcutqbnw as get_DefaultDelay } from './CoroutineContext.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Key_instancesrycfl6s632h as Key_instance } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Duration__isPositive_impl_tvkkt23gv5wbwkofeq3 as Duration__isPositive_impl_tvkkt2,
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  Duration__plus_impl_yu9v8fpg0wg84z6tem as Duration__plus_impl_yu9v8f,
  _Duration___get_inWholeMilliseconds__impl__msfiryaqt4g7dl3tjf as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_NANOSECONDS_getInstance93t9qglyuqwo as DurationUnit_NANOSECONDS_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *delay(timeMillis, $completion) {
  if (timeMillis <= 0n)
    return Unit_instance;
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.b11();
    if (timeMillis < 9223372036854775807n) {
      get_delay(cancellable.mc()).o13(timeMillis, cancellable);
    }
    return cancellable.ly();
  });
  return Unit_instance;
}
function invokeOnTimeout(timeMillis, block, context) {
  return get_DefaultDelay().p13(timeMillis, block, context);
}
var DelayClass;
function Delay() {
  if (DelayClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Delay', VOID, VOID, VOID, [1]);
    DelayClass = $;
  }
  return DelayClass;
}
function get_delay(_this__u8e3s4) {
  var tmp = _this__u8e3s4.yc(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay()) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
}
var DelayWithTimeoutDiagnosticsClass;
function DelayWithTimeoutDiagnostics() {
  if (DelayWithTimeoutDiagnosticsClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay()], [1]);
    DelayWithTimeoutDiagnosticsClass = $;
  }
  return DelayWithTimeoutDiagnosticsClass;
}
function *delay_0(duration, $completion) {
  return yield* /*#__NOINLINE__*/delay(toDelayMillis(duration), $completion);
}
function toDelayMillis(_this__u8e3s4) {
  var tmp;
  switch (Duration__isPositive_impl_tvkkt2(_this__u8e3s4)) {
    case true:
      // Inline function 'kotlin.time.Companion.nanoseconds' call

      Companion_getInstance();
      var tmp$ret$0 = toDuration(999999n, DurationUnit_NANOSECONDS_getInstance());
      tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(Duration__plus_impl_yu9v8f(_this__u8e3s4, tmp$ret$0));
      break;
    case false:
      tmp = 0n;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
//region block: exports
export {
  delay as delay3147v9lzv1xxn,
  delay_0 as delay1yesbzthrp6ln,
  DelayWithTimeoutDiagnostics as DelayWithTimeoutDiagnostics19ibxwhhgbjz0,
  Delay as Delay9umexudtwyie,
  get_delay as get_delaynv5kl66dta33,
};
//endregion

//# sourceMappingURL=Delay.mjs.map
